import React, { Component } from 'react';
import classnames from 'classnames';
import { getEmptyImage } from 'react-dnd-html5-backend'
import { ItemTypes, PanelTypes, ModuleTypes } from '../../constants/sidebar/DragAndDropTypes';
import { DragSource, DropTarget } from 'react-dnd'
import { connect } from 'react-redux'
import { moveInModule, moveOutModule, removeModule } from '../../actions/sidebar'
import { isDescendant } from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper";

@connect(state => ({
}), dispatch => ({
    handleMoveInModule: (targetName, index, module) => {
        dispatch(moveInModule(targetName, index, module))
    },
    handleMoveOutModule: (panelName, moduleId) => {
        dispatch(moveOutModule(panelName, moduleId))
    },
    handleRemoveModule: (panelName, module) => {
        dispatch(removeModule(panelName, module))
    },
    dispatch
}))
@DragSource(ItemTypes.MODULE, {
    beginDrag(props) {
        return {
            from : props.panelIndex,
            module: props.module,
            index: props.index,
            moveFromPanel: props.moveOut,
            draggingId : props.module.moduleId,
        }
    },
    endDrag(props){

    },
    isDragging(props, monitor) {
        return props.module.moduleId === monitor.getItem().module.moduleId;
    }
}, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    })
)
@DropTarget(ItemTypes.MODULE, {
    canDrop(props, monitor) {
        return false;
    },
    drop(props, monitor, component) {

        if(this.canDrop(props, monitor)) {
            let draggingItem = monitor.getItem();
            const hoverIndex = props.index;

            props.moveIn(draggingItem, hoverIndex, draggingItem.from);
        }
    },
    hover(props, monitor, component) {
        if(this.canDrop(props, monitor)) {
            const draggingItem = monitor.getItem();
            const hoverIndex = props.index;

            // 자기 자신의 위에 있으면 hover 처리 하지 않음
            if (draggingItem.module.moduleId === props.module.moduleId) {
                return;
            }

            props.moveIn(draggingItem, hoverIndex, draggingItem.from);
        }
    }
}, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
}))
class UserModule extends Component {

    constructor(props){
        super(props);

        this.state = {
            open_layer : false,
        };

        this.toggleLayer = this.toggleLayer.bind(this);
        this.moveToSidebar = this.moveToSidebar.bind(this);
        this.displayModuleDeleteButton = this.displayModuleDeleteButton.bind(this);
        this.handleWindowClick = this.handleWindowClick.bind(this);
    }

    componentDidMount() {
        const { connectDragPreview } = this.props;
        connectDragPreview(getEmptyImage(), {
            captureDraggingState: true
        });

		WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
    }

    handleWindowClick(e) {
        const { module } = this.props;
        const { open_layer } = this.state;
        const root = this.refs[module.moduleId];
        let target = e.target;

        if(open_layer && (!isDescendant(root, target))){
            this.toggleLayer();
        }
    }

    toggleLayer() {
        const { sidebarCount } = this.props;
        if(sidebarCount === 1) {
            this.moveToSidebar(0);
        }else {
            this.setState({
                open_layer: !this.state.open_layer
            })
        }
    }

    moveToSidebar(sidebarNum) {

        const { handleMoveInModule, handleMoveOutModule, module, sidebarCount } = this.props;
        const thisPanelIdx = PanelTypes.USER;
        const sidebarPanelIdx = PanelTypes.SIDEBAR + sidebarNum;
        handleMoveInModule(sidebarPanelIdx, 0, module);
        handleMoveOutModule(thisPanelIdx, module.moduleId);
        if(sidebarCount > 1) {
            this.toggleLayer();
        }
    }

    render() {

        const { module, sidebarCount } = this.props;
        const { open_layer } = this.state;
        const { connectDropTarget, connectDragSource, isDragging } = this.props;

        let sideBarList = [];

        for(let i = 0; i < sidebarCount; i++)
            sideBarList.push(<li>
                <label className="lab_btn">
                    사이드바{i + 1}
                    <input type="button" className="btn_g" value={i} onClick={(e) => this.moveToSidebar(i)}/>
                </label>
            </li>);

        return connectDropTarget(
            <div className="bundle_item">
                <div className={classnames({'insert_item': isDragging})}>
                    <div className="item_order" id={module.moduleId}>
                        <div className="basic_item">
                            {
                                connectDragSource(<div className="wrap_drag">
                                    <span className="ico_blog ico_drag" />
                                </div>)
                            }
                            <span className="txt_name">{ module.type===ModuleTypes.PLUGIN ? <span className="txt_plugin">[플러그인] </span>:''}{module.title}</span>
                            { this.displayModuleDeleteButton(module) }
                            <div ref={module.moduleId} className={classnames('opt_sidebar', {'opt_open': open_layer && !isDragging})}>
                                <label className="lab_btn lab_add">
                                    <span className="wrap_icon">
                                        <span className="ico_blog">추가</span>
                                    </span>
                                    <input type="button" className="btn_g" value="추가" onClick={() => this.toggleLayer()}/>
                                </label>
                                <div className="layer_opt">
                                    <ul className="list_opt">
                                        {sideBarList}
                                    </ul>
                                    <div className="ico_blog ico_arr"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    displayModuleDeleteButton(module) {

        const { handleRemoveModule, panelIndex } = this.props;

        return <div className="order_btn">
                <label className="lab_btn">
                    <span className="txt_btn">삭제</span>
                    <input type="button" className="btn_g" value="편집" onClick={(e) => handleRemoveModule(panelIndex, module)}/>
                </label>
            </div>

    }
}

export default UserModule;
